// Saved column preferences merged OVER the defaults: a column added later appears with its default, an explicit user choice (true or false) is kept,
// malformed storage falls back to the defaults.
export function mergePrefs(defaults, raw) {
  try { const saved = JSON.parse(raw || '{}'); return { ...defaults, ...(saved && typeof saved === 'object' && !Array.isArray(saved) ? saved : {}) }; } catch { return { ...defaults }; }
}
